import axios from "axios";
import { ADMIN_SESSION_KEY } from "../utils/impersonationConstants";
import { savePostLoginRedirect } from "../utils/postLoginRedirect";
import { getActivityContextHeaders } from "../utils/activityLog";

const baseURL = process.env.REACT_APP_BASE_API_URL;

const axiosInstance = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Client timezone + (only with the user's permission) browser geolocation for the Activity
// Log's "Location" column — see utils/activityLog.js. Read per request so a fix obtained after
// page load is picked up.
axiosInstance.interceptors.request.use((config) => {
  Object.entries(getActivityContextHeaders()).forEach(([name, value]) => {
    config.headers[name] = value;
  });
  return config;
});

// Add response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // A naturally-expired impersonation token (1h) lands here before the banner's Exit
      // button is ever clicked — restore the admin's stashed session instead of a full
      // logout, so exiting impersonation never requires re-entering a password.
      const stash = localStorage.getItem(ADMIN_SESSION_KEY);
      if (stash) {
        localStorage.setItem("token", JSON.parse(stash).token);
        localStorage.removeItem(ADMIN_SESSION_KEY);
      } else {
        // Session expired on this page — return here after logging back in (see Login.jsx).
        savePostLoginRedirect(window.location.pathname + window.location.search);
        localStorage.clear();
      }
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
